import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import SphereNavigationRoutes from '@common/enums/query-params/sphere-navigation-routes';
import SideNavLayout from 'components/ui/SideNavLayout';
import { navigationOpenStorageName } from 'components/ui/MainNavigationBar';
import FleetNavigationBar from './FleetNavigationBar';
import FleetLogo from './FleetLogo';
import SphereLogo from '../../media/logo512.png';

const FleetLayout: React.FC<{
  children: React.ReactNode;
  /** Opens the dashboard configuration dialog for the currently selected dashboard. */
  onEditDashboard: () => void;
}> = ({ children, onEditDashboard }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const backToSphereHandler = () => {
    localStorage.setItem(navigationOpenStorageName, 'false');
    navigate(SphereNavigationRoutes.Dashboard);
  };

  return (
    <SideNavLayout
      dataTestId="fleet-layout"
      logo={<FleetLogo showTitle showIcon={!matchesSmDown} />}
      actions={
        <Tooltip title={`${t('fleet-management-back-to')} Sphere`}>
          <IconButton onClick={backToSphereHandler} data-testid="fleet-back-to-sphere-button">
            <img
              src={SphereLogo}
              alt={`${t('fleet-management-back-to')} Sphere`}
              style={matchesSmDown ? { width: 24, height: 24 } : { width: 32, height: 32 }}
            />
          </IconButton>
        </Tooltip>
      }
      renderNavigationBar={(isNavOpen, onNavChangeHandler) => (
        <FleetNavigationBar
          isNavOpen={isNavOpen}
          onNavChangeHandler={onNavChangeHandler}
          onEditDashboard={onEditDashboard}
        />
      )}
    >
      {children}
    </SideNavLayout>
  );
};

export default FleetLayout;
